module.exports = __webpack_public_path__ + "static/media/zak.54205498.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zak.jpg
// module id = 100
// module chunks = 0